import { useMemo } from 'react'
import qs from 'qs'
import { getDefaultUserDriverCategory } from 'selectors/carHireSelectors'
import { useAppSelector } from 'hooks/reduxHooks'
import { usePlaceByCoords } from 'hooks/usePlace'

export interface CarHireSearchParams {
  pickUpTime: string,
  dropOffTime: string,
  age?: number,
  ageCategory: number,
  isPickUpAtAirport: boolean,
  pickUpSearchType: string,
  dropOffSearchType: string,
  pickUpName?: string,
  dropOffName?: string,
  pickUpId?: string,
  dropOffId?: string,
  pickUpDate?: string,
  dropOffDate?: string,
  bundledOrderId?: string,
  pickUpLatitude?: number,
  pickUpLongitude?: number,
  dropOffLatitude?: number,
  dropOffLongitude?: number,
}

export function useCarHireSearchLink(
  startDate?: string,
  endDate?: string,
  latitude?: number,
  longitude?: number,
  bundledOrderId?: string,
  pickUpTime?: string,
  dropOffTime?: string,
  age?: number,
  ageCategory?: number,
  pickUpName?: string,
  dropOffName?: string,
  pickUpId?: string,
  dropOffId?: string,
  pickUpSearchType?: string,
  dropOffSearchType?: string,
): [string, boolean] {
  const [defaultAgeCategory, defaultAge] = useAppSelector(getDefaultUserDriverCategory)
  const [place, fetching] = usePlaceByCoords(latitude, longitude)

  const carHireSearchLink = useMemo(() => {
    const hasLoadedPlace = latitude && longitude && place
    const hasReceivedPlace = pickUpName && dropOffName && pickUpId && dropOffId
    const hasReceivedDates = startDate && endDate

    const emptyPlace = !hasLoadedPlace && !hasReceivedPlace
    if (emptyPlace || !hasReceivedDates) return '/car-hire'

    const carHireSearchParams: CarHireSearchParams = {
      pickUpName: pickUpName || place?.canonicalName,
      dropOffName: dropOffName || place?.canonicalName,
      pickUpId: pickUpId || place?.id,
      dropOffId: dropOffId || place?.id,
      pickUpDate: startDate,
      dropOffDate: endDate,
      pickUpTime: pickUpTime || '10:00',
      dropOffTime: dropOffTime || '10:00',
      age: age || defaultAge,
      ageCategory: ageCategory || defaultAgeCategory,
      isPickUpAtAirport: false,
      pickUpSearchType: pickUpSearchType || 'geo',
      dropOffSearchType: dropOffSearchType || 'geo',
      bundledOrderId,
      pickUpLatitude: latitude,
      pickUpLongitude: longitude,
      dropOffLatitude: latitude,
      dropOffLongitude: longitude,
    }

    return `/search/car-hire?${qs.stringify(carHireSearchParams)}`
  }, [startDate, endDate, place, age, ageCategory, bundledOrderId, latitude, longitude, pickUpTime, dropOffTime, defaultAge, defaultAgeCategory, pickUpName, dropOffName, pickUpId, dropOffId, pickUpSearchType, dropOffSearchType])

  return [carHireSearchLink, fetching]
}
